export default "__VITE_ASSET__30d31971__"